import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchaseUrl, recentPurchases } from '../data/content';
export function FloatingElements() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [index, setIndex] = useState(0);
  const [cta, setCta] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const delay = index === 0 ? 4500 : 7500;
    const showTimer = window.setTimeout(() => setVisible(true), delay);
    const rotateTimer = window.setTimeout(() => {
      setVisible(false);
      setIndex(value => (value + 1) % recentPurchases.length);
    }, delay + 5500);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(rotateTimer);
    };
  }, [dismissed, index]);
  useEffect(() => {
    const onScroll = () => setCta(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const [name, place] = recentPurchases[index];
  return <>
      <AnimatePresence data-id="element-140" data-mp="dqq8txmlruzi">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 26,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} transition={{
        type: 'spring',
        stiffness: 280,
        damping: 24
      }} className="fixed bottom-4 left-4 z-[60] max-w-[290px] overflow-hidden rounded-2xl border-[3px] border-accent bg-primary p-3 pr-8 shadow-[0_18px_42px_rgba(10,22,40,.45)]" aria-live="polite" data-id="element-141" data-mp="dtm7xpa6sppj">
            <div className="absolute inset-y-0 left-0 w-1.5 bg-accent" data-id="element-142" data-mp="11g15b2wx737u" />
            <button onClick={() => setDismissed(true)} className="absolute right-1.5 top-1.5 rounded p-1 text-slate-300 transition-colors duration-150 ease-out hover:text-white" aria-label="Cerrar notificación" data-id="element-143" data-mp="15jqnnan04okf">
              <XIcon className="h-3.5 w-3.5" data-id="element-144" data-mp="32jlgpsythp8t" />
            </button>
            <div className="flex gap-3" data-id="element-145" data-mp="32gz0l4xv21ez">
              <span className="h-fit rounded-full border-2 border-amber-100 bg-accent p-2 text-ink shadow-sm" data-id="element-146" data-mp="3gaq7e5k7j770">
                <ShoppingBagIcon className="h-5 w-5" data-id="element-147" data-mp="3bioz0uq5u0m9" />
              </span>
              <div data-id="element-148" data-mp="3q84o86a1lxzu">
                <p className="flex items-center gap-1 text-[10px] font-black uppercase tracking-[.12em] text-accent" data-id="element-149" data-mp="3q7l5woghd7la">
                  <CheckCircle2Icon className="h-3 w-3" data-id="element-150" data-mp="3l91hmheezjpr" /> Compra reciente
                </p>
                <p className="mt-1 text-xs leading-snug text-slate-200" data-id="element-151" data-mp="32n8cvr3bxxp">
                  <b className="text-white" data-id="element-152" data-mp="3u9znl58ey1az">{name}</b> compró el libro digital{' '}
                  <b className="text-accent" data-id="element-153" data-mp="24v1ih8ne7y3k">Combo Completo Hipertrofia 2026</b>
                </p>
                <p className="mt-1 flex items-center gap-1 text-[10px] font-semibold text-slate-300" data-id="element-154" data-mp="1zwgk7erpbohr">
                  <MapPinIcon className="h-3 w-3 text-accent" data-id="element-155" data-mp="fdnvu01kg9w0" />
                  {place} · Argentina · hace {index * 4 + 2} min
                </p>
              </div>
            </div>
          </motion.aside>}
      </AnimatePresence>

      <AnimatePresence data-id="element-156" data-mp="6lci9erjwgxg">
        {cta && <motion.div initial={{
        y: 80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 80,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-3 left-3 right-3 z-50 flex justify-center md:left-auto md:right-6" data-id="element-157" data-mp="anftc2ab5ji7">
            <a href={purchaseUrl} target="_blank" rel="noopener noreferrer" className="w-full rounded-2xl border border-accent/60 bg-primary px-6 py-3.5 text-center text-sm font-extrabold uppercase tracking-wide text-white shadow-[0_16px_34px_rgba(10,29,56,.35)] transition-colors duration-150 ease-out hover:bg-primary-dark focus:outline-none focus:ring-4 focus:ring-accent/30 md:w-auto" data-id="element-158" data-mp="3jtfkexfys6az">
              💪 Quiero mi Combo Hipertrofia · $19.990 →
            </a>
          </motion.div>}
      </AnimatePresence>
    </>;
}